import { useTranslation } from "react-i18next";

import { ClientParametersContainerProps } from "./ClientParameters.types";

import {
  getSplitTaxableIncomeOptions,
  getFamilyTaxableIncomeOptions,
} from "constants/calculator";

import ClientParameters from "./ClientParameters";

const ClientParametersContainer = ({
  activeTab,
  isDesktop,
  calculatorType,
}: ClientParametersContainerProps) => {
  const { t } = useTranslation();

  const familyTaxableIncomeOptions = getFamilyTaxableIncomeOptions(t);
  const splitTaxableIncomeOptions = getSplitTaxableIncomeOptions(t);

  return (
    <ClientParameters
      activeTab={activeTab}
      isDesktop={isDesktop}
      calculatorType={calculatorType}
      splitTaxableIncomeOptions={splitTaxableIncomeOptions}
      familyTaxableIncomeOptions={familyTaxableIncomeOptions}
    />
  );
};

export default ClientParametersContainer;
